import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.vector.ImageVector
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.resources.vectorResource
import org.jetbrains.skia.skottie.Animation

class WasmPlatform: Platform {
    override val name: String = "Web with Kotlin/Wasm"
}

actual fun getPlatform(): Platform = WasmPlatform()

@Composable
actual fun loadResourceImage(drawableResource: DrawableResource): Painter {
    return painterResource(drawableResource)
}

@Composable
actual fun loadResourceVector(drawableResource: DrawableResource): ImageVector {
    return vectorResource(drawableResource)
}

@Composable
actual fun loadResourceString(drawableResource: StringResource): String {
    return stringResource(drawableResource)
}

actual fun logD(message: String) {
    println(message)
}

@Composable
actual fun LottieAnimation(
    modifier: Modifier,
    animationData: String
) {
    val animation = Animation.makeFromString(animationData)
    InfiniteAnimation(animation, modifier)
}
